import ContactForm from "../components/contact-form/contact-form.component";

const Contact = () => (
    <div style={{maxWidth: "1920px", margin: "auto"}}>
        <ContactForm />
    </div>
)

export default Contact;